import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from '@arco-design/web-react';
import { useSelector } from 'react-redux';

import { guestIntakePath } from '../../constants/guestIntake';
import { useAuthSessionReady } from '../../hooks/useAuthSessionReady';
import { useEventIntakeEnabled } from '../../hooks/useEventIntakeEnabled';
import { RootState } from '../../store/store';

type ProfileRouteGuardProps = {
  children: ReactNode;
};

export function ProfileRouteGuard({ children }: ProfileRouteGuardProps): JSX.Element {
  const eventIntakeEnabled = useEventIntakeEnabled();
  const authReady = useAuthSessionReady();
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const user = useSelector((state: RootState) => state.user.user);

  if (!configLoaded || !authReady) {
    return <Spin style={{ margin: '120px auto' }} size={32} />;
  }

  if (eventIntakeEnabled && user?.isGuest) {
    return <Navigate to={guestIntakePath()} replace />;
  }

  return <>{children}</>;
}
